import ky from "ky";
import { LESSON, MODEL_USER } from "./consts";
import { Manifest, SaveResponse, Summary } from "./types";

let cache = new Map();

const fetchData = <T>(url: string) => {
  if (!cache.has(url)) {
    cache.set(url, ky.get(url, { retry: 0 }).json());
  }
  return cache.get(url) as Promise<T>;
};

const isLocalDev =
  typeof window === "object" && window.location.host.includes("localhost");

const getBucketUrl = (user: string) => {
  if (isLocalDev && user !== MODEL_USER) {
    return manifest.localBucketUrl;
  }
  return manifest.bucketUrl;
};

export const getObjectKey = (user: string, lesson: string, word: string) =>
  `${user}/${lesson}/${normalizeId(word)}`;

export const getReadAudioUrl = (user: string, word: string, version = "") =>
  `${getBucketUrl(user)}/${getObjectKey(user, LESSON, word)}${
    version ? `?v=${version}` : ""
  }`;

export const getReadSummaryUrl = (user: string) =>
  `${getBucketUrl(user)}/${getObjectKey(user, LESSON, "_summary")}`;

export const getSummary = (user: string) =>
  fetchData<Summary>(getReadSummaryUrl(user));

let manifest: Manifest;
export const getManifest = () => fetchData<Manifest>("/api/manifest");
// hacky way to avoid creating async function for getManifest,
// which with `async` create a new promise everytime (I think) and it's not cached for Suspend
export const setManifest = (data: Manifest) => (manifest = data);

// Naive normalization
export const normalizeId = (word: string) => word.replaceAll(" / ", "_");

const getServerObjectUrl = (word: string) =>
  `/api/audio/${LESSON}/${normalizeId(word)}`;

export const saveAudio = (word: string, blob: Blob) =>
  ky.put(getServerObjectUrl(word), { body: blob }).json<SaveResponse>();

export const saveSummary = (summary: Summary) =>
  ky
    .put(getServerObjectUrl("_summary"), { json: summary })
    .json<SaveResponse>();

export const deleteAudio = (word: string) =>
  ky.delete(getServerObjectUrl(word));
